import script from "./chat-limit-card.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-limit-card.vue?vue&type=script&setup=true&lang=js"

import "./chat-limit-card.vue?vue&type=style&index=0&id=6c31a1aa&lang=css"

const __exports__ = script;

export default __exports__